import React from 'react';

import { Stack, styled } from '@mui/material';
import { useDeviceType } from 'contexts/ThemeContext/hooks/useDeviceType';
import { ResourcesBulletPoints } from './ResourcesBulletPoints';
import { AppStorePreview } from './AppStorePreview';
import { AppStoreButtons } from './AppStoreButtons';
import { ResourcesHeader } from './ResourcesHeader';

const DesktopStack = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  gap: theme.spacing(8),
  padding: theme.spacing(8),
}));

const MobileTabletStack = styled(Stack)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(2),
    padding: theme.spacing(2),
  },
  [theme.breakpoints.up('sm')]: {
    gap: theme.spacing(4),
    padding: theme.spacing(6),
  },
}));

export const ResourcesContent = () => {
  const { isDesktop } = useDeviceType();

  if (isDesktop) {
    return (
      <DesktopStack direction="row" id="resources__desktop-content">
        <Stack direction="column" spacing={4}>
          <ResourcesHeader />
          <ResourcesBulletPoints />
          <AppStoreButtons />
        </Stack>
        <AppStorePreview />
      </DesktopStack>
    );
  }

  return (
    <MobileTabletStack direction="column" id="resources__mobile-tablet-content">
      <ResourcesHeader />
      <AppStoreButtons />
      <AppStorePreview />
      <ResourcesBulletPoints />
    </MobileTabletStack>
  );
};
